<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">出库记录</h3>
            <div class="box-tools pull-right">
              <handle @finish="finish">出库操作</handle>
            </div>
          </div>
          <div class="box-body no-padding">
            <div style="padding-top: 20px;padding-left: 20px;">
              <el-form :inline="true">
                <el-form-item label="日期">
                  <el-date-picker
                      v-model="query.day"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="querySelect">查询</el-button>
                </el-form-item>
              </el-form>
            </div>

            <el-table :data="list" border v-loading="listLoading" style="width: 100%">
              <el-table-column prop="order_code" label="单据编号" width="160"></el-table-column>
              <el-table-column prop="custom" label="客户"></el-table-column>
              <el-table-column prop="product_model_code" label="存货编号"></el-table-column>
              <el-table-column prop="product_name" label="存货名称"></el-table-column>
              <el-table-column label="出库成功条码">
                <template slot-scope="scope">
                  <div>
                    <in-detail :info="scope.row.success" title="出库成功条码">
                      {{ scope.row.success.length }}
                    </in-detail>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="出库成功箱码">
                <template slot-scope="scope">
                  <div>
                    <in-detail :info="scope.row.success_box" title="出库成功箱码">
                      {{ scope.row.success_box.length }}
                    </in-detail>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="条码不是系统生成">
                <template slot-scope="scope">
                  <div>
                    <in-detail :info="scope.row.fault_bar_code_not_build" title="条码不是系统生成">
                      {{ scope.row.fault_bar_code_not_build.length }}
                    </in-detail>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="条码未绑定">
                <template slot-scope="scope">
                  <div>
                    <in-detail :info="scope.row.fault_bar_code_not_bind" title="条码未绑定">
                      {{ scope.row.fault_bar_code_not_bind.length }}
                    </in-detail>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="条码未入库">
                <template slot-scope="scope">
                  <div>
                    <in-detail :info="scope.row.fault_bar_code_not_inventory" title="条码未入库">
                      {{ scope.row.fault_bar_code_not_inventory.length }}
                    </in-detail>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="箱码不是系统生成">
                <template slot-scope="scope">
                  <div>
                    <in-detail :info="scope.row.fault_box_code_not_build" title="箱码不是系统生成">
                      {{ scope.row.fault_box_code_not_build.length }}
                    </in-detail>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="箱码未生效">
                <template slot-scope="scope">
                  <div>
                    <in-detail :info="scope.row.fault_box_code_not_bind" title="箱码未生效">
                      {{ scope.row.fault_box_code_not_bind.length }}
                    </in-detail>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="箱码未绑定">
                <template slot-scope="scope">
                  <div>
                    <in-detail :info="scope.row.fault_box_code_not_inventory" title="箱码未绑定">
                      {{ scope.row.fault_box_code_not_inventory.length }}
                    </in-detail>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="箱码没数据">
                <template slot-scope="scope">
                  <div>
                    <in-detail :info="scope.row.fault_box_code_not_data" title="箱码没数据">
                      {{ scope.row.fault_box_code_not_data.length }}
                    </in-detail>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div style="padding: 10px">
              <el-pagination
                  background
                  layout="total, prev, pager, next"
                  :total="total"
                  :page-size="query.size"
                  :current-page="query.page"
                  @current-change="pageChange"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import qs from "qs";

import InDetail from "./InDetail.vue";
import Handle from "./Handle.vue";

export default {
  components: {InDetail, Handle},
  data() {
    return {
      params: {},
      query: {
        day: '',
        page: 1,
        size: 10,
      },
      list: [],
      total: 0,
      listLoading: false,
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  mounted() {
    const _this = this;
    _this.query = Object.assign(_this.query, _this.$route.query);
    _this.query.page = parseInt(_this.query.page);
    _this.query.size = parseInt(_this.query.size);
    _this.listLoading = true;
    _this.authInit(_this).then(() => {
      _this.loadList();
    });
  },
  methods: {
    ...mapActions(["authInit"]),
    updateUrl() {
      const _this = this;
      const url = _this.$route.path + "?" + qs.stringify(_this.query);
      _this.$router.replace({path: url});
    },
    // 获取列表
    loadList() {
      const _this = this;
      _this.$api.wareOutList(_this.query)
          .then(res => {
            _this.listLoading = false;
            _this.list = res.list;
            _this.total = res.total;
            _this.updateUrl();
          })
          .catch(err => {
            _this.listLoading = false;
            _this.$message.error(err.msg);
          })
    },
    // 分页
    pageChange(page) {
      const _this = this;
      _this.query.page = parseInt(page);
      _this.listLoading = true;
      _this.loadList();
    },
    // 筛选
    querySelect() {
      const _this = this;
      _this.query.page = 1;
      _this.listLoading = true;
      _this.loadList();
    },
    finish() {
      const _this = this;
      _this.query.page = 1;
      _this.listLoading = true;
      _this.loadList();
    },
  },
};
</script>

<style scoped>
.custom-tree-node {
  display: flex;
  justify-content: space-between;
}

.custom-tree-node-name {
  width: 400px;
}
</style>